<template>
  <main>
    <section>
      <div class="icon">
        <Logo />
      </div>
      <slot />
    </section>
  </main>
</template>

<script lang="ts" setup>
import Logo from '@images/logo.svg?component';
</script>

<style lang="scss" scoped>
main {
  @apply flex flex-col justify-center items-center;
  @apply bg-primary;
}

section {
  @apply flex flex-col items-center gap-y-12;
  @apply bg-white drop-shadow rounded-4;
  @apply py-10 px-20;
  @apply text-center;

  width: min(100%, px(600));
}

.icon {
  @apply bg-primary rounded-4;
  @apply px-4 py-4;
  width: px(148);
  height: px(90);

  :deep(path){
    fill: white;
  }
}
</style>
